<div class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
  <div class="max-w-3xl mx-auto px-4 pt-3 pb-4">
    <div *ngIf="semContexto"
      class="mb-4 rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-4 text-sm text-amber-900 dark:text-amber-200">
      Selecione um contexto para visualizar os acompanhamentos pedagógicos.
    </div>

    <ng-container *ngIf="!semContexto">
      <ng-container *ngIf="carregandoTela || carregandoConteudoCard || periodos.length">
        <section class="mb-[17px] flex min-w-0 items-center gap-2 px-1">
          <div class="min-w-0 basis-[42%]">
            <app-page-title title="Acompanhamento pedagógico"></app-page-title>
          </div>

          <div class="min-w-0 basis-[58%]">
            <app-periodo-select [options]="periodoOptions" [selectedId]="periodoSelecionado?.id ?? null"
              [disabled]="carregandoTela" (optionSelected)="onPeriodoOptionSelected($event)">
            </app-periodo-select>
          </div>
        </section>

        <section class="mb-[17px]">
          <button type="button" (click)="adicionarAcompanhamento()"
            class="inline-flex h-[2.65rem] px-4 items-center gap-2 rounded-[1rem] bg-[#3f79d8] hover:bg-[#356fcc] text-white transition-all duration-200">

            <lucide-icon name="plus" class="w-4 h-4"></lucide-icon>
            <span class="text-sm font-medium">Acompanhamento</span>
          </button>
        </section>

        <section class="mb-[16px] px-1">
          <div class="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-[0.65rem] items-center">
            <div
              class="flex h-[2.5rem] overflow-hidden rounded-[0.14rem] border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900">
              <input type="text" [(ngModel)]="termoAluno" (ngModelChange)="onFiltroChange()"
                placeholder="Buscar um aluno"
                class="min-w-0 flex-1 border-0 bg-transparent px-[0.8rem] text-[13px] text-gray-900 dark:text-gray-100 outline-none placeholder:text-gray-400">
              <div
                class="flex w-[2.5rem] shrink-0 items-center justify-center border-l border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200">
                <lucide-icon name="search" class="w-[1.05rem] h-[1.05rem]"></lucide-icon>
              </div>
            </div>

            <app-datepicker variant="inline" [dataSelecionada]="filtroDataSelecionada" [referenceDate]="_hoje"
              dateConstraintMode="past" placeholder="Buscar por data" [showClearIcon]="true" [showActions]="false"
              (dateChange)="onFiltroDataChange($event)">
            </app-datepicker>
          </div>

          <div class="mt-[17px] flex items-center gap-2">
            <app-acompanhamento-ordenacao-dropdown [aberta]="ordenacaoDropdownAberta" [opcoes]="opcoesOrdenacao"
              [selecionada]="ordenacaoSelecionada" (toggle)="toggleOrdenacaoDropdown()"
              (selecionar)="selecionarOrdenacao($event)" (fechar)="ordenacaoDropdownAberta = false">
            </app-acompanhamento-ordenacao-dropdown>
          </div>
        </section>
      </ng-container>

      <!-- Sem períodos (sem calendário escolar) -->
      <div *ngIf="!carregandoTela && !carregandoConteudoCard && !periodos.length"
        class="flex flex-col items-center justify-center py-16 px-6 text-center space-y-6">
        <div class="relative">
          <div class="w-24 h-24 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center">
            <lucide-icon name="alert-triangle" class="w-12 h-12 text-yellow-600 dark:text-yellow-500" [strokeWidth]="2">
            </lucide-icon>
          </div>
        </div>
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
          Esta turma não possui calendário escolar definido
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 max-w-md leading-relaxed">
          Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de
          Turmas
        </p>
      </div>

      <app-acompanhamento-list [registros]="registros" [carregando]="carregandoConteudoCard"
        [possuiPeriodos]="!!periodos.length" (editar)="editarRegistro($event)" (excluir)="excluirRegistro($event)"
        (togglePublicacao)="togglePublicacao($event)">
      </app-acompanhamento-list>

      <div *ngIf="carregandoTela" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
        <div class="bg-white dark:bg-gray-800 rounded-lg p-8 flex flex-col items-center shadow-lg max-w-md mx-4">
          <div class="mb-4">
            <div class="animate-spin rounded-full w-12 h-12 border-[3px] border-blue-500 border-t-transparent"
              role="status">
              <span class="sr-only">Carregando...</span>
            </div>
          </div>
          <h4 class="text-lg font-semibold text-gray-800 dark:text-gray-100">Carregando dados...</h4>
        </div>
      </div>

      <div *ngIf="confirmacao.aberta && confirmacao.tipo === 'descartar-formulario'"
        class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[70] px-3 sm:px-4">
        <div
          class="w-full max-w-[21.4rem] rounded-[0.9rem] border border-[#d7dde7] bg-white dark:bg-gray-800 shadow-[0_18px_45px_rgba(15,23,42,0.22)] px-[0.9rem] py-[0.9rem] sm:max-w-[22.75rem] sm:rounded-[0.95rem] sm:px-[0.95rem] sm:py-[0.95rem] lg:max-w-[23rem]">
          <div>
            <h3 class="text-[1.03rem] font-semibold leading-5 text-gray-900 dark:text-gray-100">Confirmar ação</h3>
            <p class="mt-[0.7rem] text-[0.89rem] leading-[1.35rem] text-gray-500 dark:text-gray-300">
              Existem <span class="font-semibold text-gray-700 dark:text-gray-100">alterações não salvas</span>.<br>
              Deseja salvá-las?
            </p>
          </div>

          <div class="mt-[1.05rem] flex gap-[0.42rem]">
            <button type="button" (click)="salvarAntesDeFecharFormulario()"
              class="flex-1 min-w-0 whitespace-nowrap h-[2.16rem] rounded-[0.25rem] bg-[#3b5dcc] px-2.5 text-center text-[12px] font-normal leading-[16px] tracking-[0] text-white hover:bg-[#2e4ea8] transition-colors">
              SALVAR
            </button>
            <button type="button" (click)="descartarFormularioSemSalvar()"
              class="flex-1 min-w-0 whitespace-nowrap h-[2.16rem] rounded-[0.25rem] border border-[#c0cad8] bg-white px-2.5 text-center text-[12px] font-normal leading-[16px] tracking-[0] text-gray-700 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200">
              NÃO SALVAR
            </button>
            <button type="button" (click)="fecharConfirmacao()"
              class="flex-1 min-w-0 whitespace-nowrap h-[2.16rem] rounded-[0.25rem] border border-[#c0cad8] bg-white px-2.5 text-center text-[12px] font-normal leading-[16px] tracking-[0] text-gray-700 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200">
              VOLTAR
            </button>
          </div>
        </div>
      </div>

      <app-confirmacao-sim-nao
        [aberta]="confirmacao.aberta && confirmacao.tipo !== 'descartar-formulario'"
        [titulo]="confirmacao.titulo"
        (confirmar)="confirmarAcao()"
        (cancelar)="fecharConfirmacao()">
        <p [innerHTML]="confirmacao.mensagem"></p>
      </app-confirmacao-sim-nao>

      <app-acompanhamento-form #formRef [aberto]="formularioAberto" [titulo]="tituloFormularioModal"
        [formulario]="formulario" [componentes]="componentes" [alunos]="alunosElegiveis"
        [carregandoAlunos]="carregandoAlunos" [destacarErroAlunos]="destacarErroAlunosFormulario"
        [somentePublicoAlvo]="somentePublicoAlvo" [isTurmaEjaModular]="isTurmaEjaModular"
        [mostrarErros]="mostrarErrosFormulario" [erros]="errosFormulario" [salvando]="salvandoFormulario"
        [formularioValidoParaSalvar]="formularioValidoParaSalvar" [limiteObservacao]="limiteObservacao"
        [maxDate]="maxDateFormulario" [campoAdicional]="campoAdicional"
        [carregandoCampoAdicional]="carregandoCampoAdicional" (fechar)="fecharFormulario()"
        (salvar)="salvarFormulario()" (excluir)="excluirDoFormulario()" (componenteChange)="selecionarComponente($event)"
        (dataChange)="onDataFormularioChange($event)" (alunoIdsChange)="onAlunoIdsFormularioChange($event)"
        (somentePublicoAlvoChange)="onSomentePublicoAlvoChange($event)">
      </app-acompanhamento-form>
    </ng-container>
  </div>
</div>